import PackageVariantIcon from 'mdi-react/PackageVariantIcon'
import SortNumericAscendingIcon from 'mdi-react/SortNumericAscendingIcon'
import SortNumericDescendingIcon from 'mdi-react/SortNumericDescendingIcon'
import { useDispatch, useSelector } from 'react-redux'

import { FilterInput } from '@/components/form/Input'
import { useText } from '@/components/i18n/hooks'
import Hits from '@/components/primitives/Hits'
import {
  getShowOnlyInStock,
  getSortedFilteredAccessoryProducts,
  getSortOrder,
  getSortParam,
  getTextFilter,
  setShowOnlyInStock,
  setSortOrder,
  setSortParam,
  setTextFilter,
} from '@/ducks/shopProductsReducer'
import withShopProductsLoaded from '@/hocs/withShopProductsLoaded'
import useRenderLimit from '@/hooks/render-limit-hook'
import { useIsBechtle } from '@/hooks/user'
import { SORT_ORDER } from '@/util/misc'

import { Product } from './StepMainProduct'

import './step-main-product.scss'

const StepAccessories = () => {
  const products = useSelector(getSortedFilteredAccessoryProducts)

  const { visibleList: visibleProducts, ListLoaderComponent } = useRenderLimit(products, 24, 15)

  const paddingLength = 3 - (visibleProducts.length % 3)

  return (
    <div className="shop-step__main-product">
      <Filter />

      <Hits amount={products.length} />

      <div className="shop-step__main-product__products">
        {visibleProducts.map(product => (
          <Product key={product.id} {...product} />
        ))}

        {paddingLength >= 1 && <div className="product padding" />}

        {paddingLength === 2 && <div className="product padding" />}
      </div>
      <ListLoaderComponent />
    </div>
  )
}

const Filter = () => {
  const dispatch = useDispatch()
  const textFilter = useSelector(getTextFilter)
  const isBechtle = useIsBechtle()
  const sortParam = useSelector(getSortParam)
  const sortOrder = useSelector(getSortOrder)
  const showOnlyInStock = useSelector(getShowOnlyInStock)

  const productFilterPlaceholderText = useText('supersearch...')
  const sortByPriceTitle = useText(`sort by price`)
  const showOnlyInStockTitle = useText(`show only products in stock`)

  const toggleSorting = () => {
    if (!sortParam) {
      dispatch(setSortParam('buying_price'))
      return
    }
    if (sortOrder === SORT_ORDER.ASC) {
      dispatch(setSortOrder(SORT_ORDER.DESC))
      return
    }
    dispatch(setSortOrder(SORT_ORDER.ASC))
    dispatch(setSortParam(undefined))
  }

  return (
    <div className="shop-step__main-product__filter">
      <FilterInput
        type="text"
        placeholder={productFilterPlaceholderText}
        value={textFilter}
        onChange={e => dispatch(setTextFilter(e.target.value))}
      />

      <div className="input-container sorting" title={sortByPriceTitle}>
        <button className={sortParam === 'buying_price' ? 'selected' : ''} onClick={toggleSorting}>
          {sortOrder === SORT_ORDER.ASC ? (
            <SortNumericAscendingIcon />
          ) : (
            <SortNumericDescendingIcon />
          )}
        </button>
      </div>

      {!isBechtle && (
        <div className="input-container stock" title={showOnlyInStockTitle}>
          <button
            className={showOnlyInStock ? 'selected' : ''}
            onClick={() => dispatch(setShowOnlyInStock(!showOnlyInStock))}
          >
            <PackageVariantIcon />
          </button>
        </div>
      )}
    </div>
  )
}

export default withShopProductsLoaded(StepAccessories)
